export default __webpack_public_path__ + "static/event-2-6d0f7c7489e7f1f695930048264f52e0.jpg";